import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import React from 'react';

function VehicleSestLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <section className="section section_consumable">
      <div className="section_container_header ">
        <h3 className="title_xsmall_b skeleton">
          {t('T10105')}
          {t('T10105')}
          {t('T10105')}
        </h3>
      </div>

      <div className="section_container skeleton">
        <ul className="consumable_list">
          <li className={clsx('consumable_item skeleton')}>
            <div className="consumable_link">
              <div className="consumable_icon_box">
                <span className="ic ic_power_train_24px" />
              </div>
              <div className="consumable_info">
                <strong className="consumable_info_title">{t('T30050')}</strong>

                <div className="badge_box">
                  <span className={clsx('badge badge_outline')}>{t('T10116')}</span>
                </div>
              </div>
              <span
                className="ic ic_arrow_forward_16px"
                aria-hidden="true"
              >
                <span className="blind">{t('T10063')}</span>
              </span>
            </div>
          </li>

          {/* 제동 */}
          <li className={clsx('consumable_item skeleton')}>
            <div className="consumable_link">
              <div className="consumable_icon_box">
                <span className="ic ic_brake_oil_24px" />
              </div>
              <div className="consumable_info">
                <strong className="consumable_info_title">{t('T30051')}</strong>

                <div className="badge_box">
                  <span className={clsx('badge badge_outline')}>{t('T10119')}</span>
                </div>
              </div>
              <span
                className="ic ic_arrow_forward_16px"
                aria-hidden="true"
              >
                <span className="blind">{t('T10063')}</span>
              </span>
            </div>
          </li>

          {/* 공조 */}
          <li className={clsx('consumable_item skeleton')}>
            <div className="consumable_link">
              <div className="consumable_icon_box">
                <span className="ic ic_vent_on_24px" />
              </div>
              <div className="consumable_info">
                <strong className="consumable_info_title">{t('T30052')}</strong>

                <div className="badge_box">
                  <span className={clsx('badge badge_outline')}>{t('T10121')}</span>
                </div>
              </div>
              <span
                className="ic ic_arrow_forward_16px"
                aria-hidden="true"
              >
                <span className="blind">{t('T10063')}</span>
              </span>
            </div>
          </li>
        </ul>

        <button
          className="btn btn_large btn_filled btn_full skeleton"
          type="button"
        >
          {t('T30024')}
        </button>
      </div>
    </section>
  );
}

export default VehicleSestLoadingKr;
